import { render } from "./LearningPlanSection.vue?vue&type=template&id=5312a08f"
import script from "./LearningPlanSection.vue?vue&type=script&lang=js"
export * from "./LearningPlanSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__